export function transformOrderCutoffUIToModel(
  disableMealCreditGracePeriod: boolean
): number | undefined {
  return disableMealCreditGracePeriod ? 0 : undefined;
}

export function transformOrderCutoffModelToUI(
  orderCutOffTime: number
): boolean {
  return orderCutOffTime === 0;
}
